import type { BasePageHeaderType } from '../../../../../page-templates/base-page/base-page-header';

export type PageTemplate = BaseTemplate | BlankTemplate | GamesListTemplate;

export const TemplateType = {
  BASE: 'base',
  BLANK: 'blank',
  GAMES_LIST: 'games_list', // former named cat filter page
} as const;

export type TemplateType = (typeof TemplateType)[keyof typeof TemplateType];

// ————— Base template ——————————————————————————

export type BaseTemplate = {
  template: typeof TemplateType.BASE;
  options?: BaseOptions;
};

export type BaseOptions = {
  allowDesktopSlideIn?: boolean;
  headerType?: BasePageHeaderType;
  requireUserAuthentication?: boolean;
  isFullScreen?: boolean;
  isFooterShown?: boolean;
  showMobileBottomBar?: boolean;
  isMobileHeaderShown?: boolean;
};

// ————— Blank page template ————————————————————

export type BlankTemplate = {
  template: typeof TemplateType.BLANK;
  options?: BlankOptions;
};

/**
 * `blank-page` renders no app chrome, so only the route-guard options consumed by
 * `Router.renderView()` apply. Chrome options (`headerType`, `isFooterShown`, …)
 * are deliberately absent so they fail to type-check instead of silently doing
 * nothing.
 */
export type BlankOptions = {
  requireUserAuthentication?: boolean;
  /**
   * Typed `false`: a BLANK view owns the full viewport and must never be
   * rendered into the desktop slide-in. Present only so `renderView()` can read
   * the property across the `PageTemplate` union.
   */
  allowDesktopSlideIn?: false;
};

// ————— Games list template ————————————————————

export type GamesListTemplate = {
  template: typeof TemplateType.GAMES_LIST;
  options?: GamesListOptions;
};

export type GamesListOptions = {
  allowDesktopSlideIn?: boolean;
  requireUserAuthentication?: boolean;
  isFooterShown?: boolean;
  showMobileBottomBar?: boolean;
  isMobileHeaderShown?: boolean;
};
